import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./home-footer.css";

const HomeFooter = () => {
  // Animation variants for a subtle fade-in effect
  const footerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.footer
      className="home-footer-section"
      variants={footerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="home-footer-container">
        <motion.div className="footer-cta" variants={itemVariants}>
          <p>
            Have questions?{" "}
            <a href="mailto:provider@syndicate.bio">Reach us</a>
          </p>
        </motion.div>

        <hr className="footer-divider" />

        <motion.div className="footer-bottom" variants={itemVariants}>
          <div className="footer-logo-container">
            <img
              src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
              alt="Direct by Syndicate Bio Logo"
              className="footer-logo"
            />
          </div>
          <div className="homepage-footer-copyright-links">
          <div className="footer-copyright">
            <span>&copy;{new Date().getFullYear()} All rights reserved</span>
          </div>
          <div className="footer-links">
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default HomeFooter;